export enum profileModals {
  ADVICE_PREMIUM = 'ADVICE_PREMIUM',
  LEVEL_UP = 'LEVEL_UP',
  CREATE_REFERRAL_COMPANY = 'CREATE_REFERRAL_COMPANY',
  CUSTOMIZATION_REFERRAL_CAMPAIGN = 'CUSTOMIZATION_REFERRAL_CAMPAIGN',
}
